import { Component, ElementRef, ViewEncapsulation, ViewChild, Renderer2, ChangeDetectorRef, HostBinding, Output, EventEmitter } from '@angular/core';
import {
    IMyDate, IMyDateRange, IMyMonth, IMyCalendarDay, IMyCalendarMonth, IMyCalendarYear,
    IMyWeek, IMyOptions, IMySelectorPosition, IMyCalendarViewChanged, IMyRangeDateSelection, IMyDateModel,
    IMyMonthRow
} from '../../interfaces/public-api';
import { UtilService } from '../../services/public-api';
import { DefaultView, KeyCode, MonthId, ResetDateType } from '../../enums/public-api';
import {
    DOT, UNDER_LINE, D, M, Y, DATE_ROW_COUNT, DATE_COL_COUNT, MONTH_ROW_COUNT, MONTH_COL_COUNT,
    YEAR_ROW_COUNT, YEAR_COL_COUNT, SU, MO, TU, WE, TH, FR, SA, EMPTY_STR, STYLE
} from '../../constants/constants';
import { TimePickerPanelComponent } from '@farris/ui-time-picker';
import { flatten, cloneDeep, sortBy, orderBy } from 'lodash-es';
import { ViewType } from '../../interfaces/my-options.interface';
import { DateTimeHelperService } from '@farris/ui-common/date';

@Component({
    selector: 'farris-datepicker-calendar',
    templateUrl: './calendar.component.html',
    providers: [UtilService],
    encapsulation: ViewEncapsulation.None
})
export class CalendarComponent {
    @ViewChild('selectorEl') selectorEl: ElementRef;
    @ViewChild('styleEl') styleEl: ElementRef;
    @ViewChild('endTimeRef') endTimeRef: TimePickerPanelComponent;
    @ViewChild('dynamicViewEle') dynamicViewEle: ElementRef;

    @HostBinding('style.position') position = 'static';

    @Output() dynamicViewShow = new EventEmitter();

    dateHlp: DateTimeHelperService = null;

    opts: IMyOptions;
    visibleMonth: IMyMonth = { monthTxt: EMPTY_STR, monthNbr: 0, year: 0, yearTxt: EMPTY_STR };
    visibleMonth_range: IMyMonth = { monthTxt: EMPTY_STR, monthNbr: 0, year: 0, yearTxt: EMPTY_STR };
    selectedMonth: IMyMonth = { monthNbr: 0, year: 0 };
    selectedMonth_range: IMyMonth = { monthNbr: 0, year: 0 };
    selectedDate: IMyDate = { year: 0, month: 0, day: 0 };
    selectedDateRange: IMyDateRange = { begin: { year: 0, month: 0, day: 0 }, end: { year: 0, month: 0, day: 0 } };
    selectedWeek: IMyWeek = { weekNbr: 0, year: 0 };
    weekDays: Array<string> = [];
    dates: Array<IMyWeek> = [];
    dates_range: Array<IMyWeek> = [];
    months: Array<IMyMonthRow> = [];
    months_range: Array<IMyMonthRow> = [];
    years: Array<Array<IMyCalendarYear>> = [];
    years_range: Array<Array<IMyCalendarYear>> = [];
    timeVlaue: string;
    timeVlaue_range: string;

    multiSelect = false;

    dayIdx = 0;
    weekDayOpts: Array<string> = [SU, MO, TU, WE, TH, FR, SA];

    selectMonth = false;
    selectMonth_range = false;
    selectYear = false;
    selectYear_range = false;
    selectTime = false;

    dateChanged: (dm: IMyDateModel, close: boolean) => void;
    calendarViewChanged: (cvc: IMyCalendarViewChanged) => void;
    rangeDateSelection: (rds: IMyRangeDateSelection) => void;
    multiDatesChanged: (dates: any[]) => void;

    closedByEsc: () => void;
    selectorPos: IMySelectorPosition = null;
    scrollDiff = 0;

    prevViewDisabled = false;
    nextViewDisabled = false;
    prevDobViewDisabled = false;
    nextDobViewDisabled = false;

    prevViewDisabled_range = false;
    nextViewDisabled_range = false;
    prevDobViewDisabled_range = false;
    nextDobViewDisabled_range = false;

    showNotify: () => void;

    /** å¤é */
    selectedDates = [];

    getTimeStr(date: Date): string {
        const hour = this.utilService.preZero(date.getHours());
        const minute = this.utilService.preZero(date.getMinutes());
        const second = this.utilService.preZero(date.getSeconds());
        return `${hour}:${minute}:${second}`;
    }
    // ç¦ç¨æ¥ææ¶é´æ§ä»¶ä¸­çæ¶é´æ®µçå°æ¶
    disabledHours = () => {
        const min = this.opts.disableUntil;
        const max = this.opts.disableSince;
        const currentDate = this.opts.dateRange ? this.selectedDateRange.begin : this.selectedDate;
        const res = this.utilService.disabledHours(min, max, currentDate);
        return res;
    }
    // ç¦ç¨æ¥ææ¶é´æ§ä»¶ä¸­çæ¶é´æ®µçåé
    disabledMinutes = (hour: number) => {
        const min = this.opts.disableUntil;
        const max = this.opts.disableSince;
        const currentDate = this.opts.dateRange ? this.selectedDateRange.begin : this.selectedDate;
        const res = this.utilService.disabledMinutes(min, max, hour, currentDate);
        return res;
    }
    // ç¦ç¨æ¥ææ¶é´æ§ä»¶ä¸­çæ¶é´æ®µçç§
    disabledSeconds = (hour: number, minute: number) => {
        const min = this.opts.disableUntil;
        const max = this.opts.disableSince;
        const currentDate = this.opts.dateRange ? this.selectedDateRange.begin : this.selectedDate;
        const res = this.utilService.disabledSeconds(min, max, hour, minute, currentDate);
        return res;
    }


    disabledHours2 = () => {
        const min = this.opts.disableUntil;
        const max = this.opts.disableSince;
        const currentDate = this.opts.dateRange ? this.selectedDateRange.end : this.selectedDate;
        const res = this.utilService.disabledHours(min, max, currentDate);
        return res;
    }
    // ç¦ç¨æ¥ææ¶é´æ§ä»¶ä¸­çæ¶é´æ®µçåé
    disabledMinutes2 = (hour: number) => {
        const min = this.opts.disableUntil;
        const max = this.opts.disableSince;
        const currentDate = this.opts.dateRange ? this.selectedDateRange.end : this.selectedDate;
        const res = this.utilService.disabledMinutes(min, max, hour, currentDate);
        return res;
    }
    // ç¦ç¨æ¥ææ¶é´æ§ä»¶ä¸­çæ¶é´æ®µçç§
    disabledSeconds2 = (hour: number, minute: number) => {
        const min = this.opts.disableUntil;
        const max = this.opts.disableSince;
        const currentDate = this.opts.dateRange ? this.selectedDateRange.end : this.selectedDate;
        const res = this.utilService.disabledSeconds(min, max, hour, minute, currentDate);
        return res;
    }

    btnDynamicDisabled = true;

    constructor(private renderer: Renderer2, private cdr: ChangeDetectorRef, private utilService: UtilService) { }

    initialize(
        opts: IMyOptions,
        defaultMonth: string,
        selectorPos: IMySelectorPosition,
        inputValue: string,
        dc: (dm: IMyDateModel, close: boolean) => void,
        cvc: (cvc: IMyCalendarViewChanged) => void,
        rds: (rds: IMyRangeDateSelection) => void,
        cbe: () => void
    ): void {
        this.opts = opts;
        this.selectorPos = selectorPos;
        this.weekDays.length = 0;
        const { defaultView, dateRange, firstDayOfWeek, dayLabels, stylesData, yearTxt, multiSelect, separator, selectedOrderBy } = this.opts;
        this.visibleMonth.yearTxt = yearTxt;
        this.visibleMonth_range.yearTxt = yearTxt;
        this.multiSelect = multiSelect;
        // if (stylesData.styles.length) {
        //     const styleElTemp: any = this.renderer.createElement(STYLE);
        //     this.renderer.appendChild(styleElTemp, this.renderer.createText(stylesData.styles));
        //     this.renderer.appendChild(this.styleEl.nativeElement, styleElTemp);
        // }

        this.dayIdx = this.weekDayOpts.indexOf(firstDayOfWeek);
        if (this.dayIdx !== -1) {
            let idx: number = this.dayIdx;
            // tslint:disable-next-line:prefer-for-of
            for (let i = 0; i < this.weekDayOpts.length; i++) {
                this.weekDays.push(dayLabels[this.weekDayOpts[idx]]);
                idx = this.weekDayOpts[idx] === SA ? 0 : idx + 1;
            }
        }
        let today: IMyDate = this.getToday();
        const isInDisableRange = this.utilService.isDisabledDate(today, this.opts);
        today = !isInDisableRange ? today : this.utilService.getNearDate(today, this.opts.disableUntil, this.opts.disableSince);

        switch (defaultView) {
            case DefaultView.Month:
                this.selectedMonth = { monthNbr: 0, year: today.year };
                this.selectedMonth_range = { monthNbr: 0, year: today.year + 1 };
                break;
            case DefaultView.Year:
                this.selectedMonth = { monthNbr: 0, year: today.year };
                this.selectedMonth_range = { monthNbr: 0, year: today.year + 10 };
                break;
            default:
                this.selectedMonth = { monthNbr: today.month, year: today.year };
                if (today.month >= 12) {
                    this.selectedMonth_range = { monthNbr: 1, year: today.year + 1 };
                } else {
                    this.selectedMonth_range = { monthNbr: today.month + this.opts.monthRangeValue, year: today.year };
                }
                break;
        }
        if (defaultMonth && defaultMonth.length) {
            this.selectedMonth = this.utilService.parseDefaultMonth(defaultMonth);
            this.selectedMonth_range = this.utilService.parseDefaultMonth(defaultMonth);
            if (this.selectedMonth_range.monthNbr >= 12) {
                this.selectedMonth_range.year++;
                this.selectedMonth_range.monthNbr = 1;
            } else {
                this.selectedMonth_range.monthNbr = this.selectedMonth_range.monthNbr + this.opts.monthRangeValue;
            }
        }

        // æ¥æå¤é
        if (this.multiSelect && inputValue) {
            this.selectedDates = inputValue.split(separator).map(n => {

                if (this.opts.returnFormat === 'yyyyMMdd') {
                    if (n.length > 8) {
                        n = this.dateHlp.formatTo(n, this.opts.returnFormat);
                    }
                }

                const _dObj = this.utilService.isDateValid(n, this.opts, true);

                return {
                    ..._dObj,
                    value: this.utilService.formatDate(_dObj, this.opts.dateFormat, this.opts.monthLabels)
                };
            });

            this.selectedDates = this.utilService.orderSelectedDates(this.selectedDates, selectedOrderBy);

        } else {
            if (!dateRange) {
                // Single date mode
                const date: IMyDate = this.utilService.isDateValid(inputValue, this.opts, true);
                if (this.utilService.isInitializedDate(date)) {
                    this.selectedDate = date;
                    const hour = this.utilService.preZero(date.hour);
                    const minute = this.utilService.preZero(date.minute);
                    const second = this.utilService.preZero(date.second);
                    this.timeVlaue = `${hour}:${minute}:${second}`;
                    this.selectedMonth = { monthNbr: date.month, year: date.year };
                }
            } else {
                // Date range mode
                const { begin, end } = this.utilService.isDateValidDateRange(inputValue, this.opts);
                if (this.utilService.isInitializedDate(begin) && this.utilService.isInitializedDate(end)) {
                    this.selectedDateRange = { begin, end };
                    const hour = this.utilService.preZero(begin.hour);
                    const minute = this.utilService.preZero(begin.minute);
                    const second = this.utilService.preZero(begin.second);
                    this.timeVlaue = `${hour}:${minute}:${second}`;
                    const _hour = this.utilService.preZero(end.hour);
                    const _minute = this.utilService.preZero(end.minute);
                    const _second = this.utilService.preZero(end.second);
                    this.timeVlaue_range = `${_hour}:${_minute}:${_second}`;

                    this.selectedMonth = { monthNbr: begin.month, year: begin.year };

                    if (begin.month === end.month && begin.year === end.year) {
                        if (end.month >= 12) {
                            this.selectedMonth_range = { monthNbr: 1, year: end.year + 1 };
                        } else {
                            let endyear = end.year;
                            if (defaultView === DefaultView.Month) {
                                endyear = endyear + 1;
                            }

                            this.selectedMonth_range = { monthNbr: end.month + this.opts.monthRangeValue, year: endyear };
                        }
                    } else {
                        if (defaultView === DefaultView.Month && begin.year === end.year) {
                            this.selectedMonth_range = { monthNbr: end.month, year: end.year + 1 };
                        } else {
                            this.selectedMonth_range = { monthNbr: end.month, year: end.year };
                        }
                    }

                    // tfs 579358
                    // let endDayWeekNbr = this.utilService.getWeekNumber(end);
                    // if (this.opts.firstDayOfWeek === 'su') {
                    //     endDayWeekNbr -= 1;
                    // }
                    // const weekNbr = this.utilService.getWeekNumber(begin) === endDayWeekNbr ? this.utilService.getWeekNumber(begin): 0;
                    const dateObj = this.opts.firstDayOfWeek == 'su' ? end: begin;
                    let weekNbr = this.utilService.getWeekNumber(dateObj);

                    this.selectedWeek = { weekNbr, year: begin.year };
                }

            }
        }

        this.dateChanged = dc;
        this.calendarViewChanged = cvc;
        this.rangeDateSelection = rds;
        this.closedByEsc = cbe;
        this.setCalendarVisibleMonth();

        if (defaultView === DefaultView.Month) {
            this.onMonthViewBtnClicked();
            if (dateRange) {
                this.onMonthViewBtnClicked(true);
            }
        } else if (defaultView === DefaultView.Year) {
            this.onYearViewBtnClicked();
            if (dateRange) {
                this.onYearViewBtnClicked(true);
            }
        }

    }

    resetDateValue(value: ResetDateType): void {
        if (value === ResetDateType.singleDate || value === ResetDateType.both) {
            this.selectedDate = this.utilService.resetDate();
        }
        if (value === ResetDateType.dateRange || value === ResetDateType.both) {
            this.selectedDateRange.begin = this.utilService.resetDate();
            this.selectedDateRange.end = this.utilService.resetDate();
        }
    }

    resetMonthYearSelect(isSecondCalendar?: boolean): void {
        if (!isSecondCalendar) {
            this.selectMonth = false;
            this.selectYear = false;
        } else {
            this.selectMonth_range = false;
            this.selectYear_range = false;
        }
    }

    onMonthViewBtnClicked(isSecondCalendar?: boolean): void {
        this.selectTime = false;
        if (!isSecondCalendar) {
            this.selectMonth = !this.selectMonth;
            this.selectYear = false;
            if (this.selectMonth) {
                this.generateMonths(isSecondCalendar);
            } else {
                this.visibleMonth.year = this.selectedMonth.year;
            }
        } else {
            this.selectMonth_range = !this.selectMonth_range;
            this.selectYear_range = false;
            if (this.selectMonth_range) {
                this.generateMonths(isSecondCalendar);
            } else {
                this.visibleMonth_range.year = this.selectedMonth_range.year;
            }
            this.cdr.detectChanges();
        }
    }

    onMonthCellClicked(cell: IMyCalendarMonth, isSecondCalendar: boolean): void {
        if (!isSecondCalendar) {
            const { year, monthNbr } = this.visibleMonth;

            const mc: boolean = cell.nbr !== monthNbr;
            this.visibleMonth = {
                monthTxt: this.opts.monthLabels[cell.nbr],
                monthNbr: cell.nbr,
                year,
                yearTxt: this.opts.yearTxt
            };
            this.selectedMonth.year = this.visibleMonth.year;

            this.selectedDate.year = this.visibleMonth.year;
            this.selectedDate.month = this.visibleMonth.monthNbr;

            if (this.opts.showType === 2) {
                this.toSelectMonth(this.visibleMonth);
            } else {
                this.generateCalendar(cell.nbr, year, mc, isSecondCalendar);
                this.selectMonth = false;
            }
        } else {
            const { year, monthNbr } = this.visibleMonth_range;

            const mc: boolean = cell.nbr !== monthNbr;
            this.visibleMonth_range = {
                monthTxt: this.opts.monthLabels[cell.nbr],
                monthNbr: cell.nbr,
                year,
                yearTxt: this.opts.yearTxt
            };
            this.selectedMonth_range.year = this.visibleMonth_range.year;
            if (this.opts.showType === 2) {
                this.toSelectMonth(this.visibleMonth_range);
            } else {
                this.generateCalendar(cell.nbr, year, mc, isSecondCalendar);
                this.selectMonth_range = false;
            }
        }
    }

    onMonthCellKeyDown(cell: IMyCalendarMonth) {
        // Make possible to move focus by arrow keys
        const { sourceRow, sourceCol } = this.getSourceRowAndColumnFromEvent(event);
        const { moveFocus, targetRow, targetCol } = this.getTargetFocusRowAndColumn(
            event,
            sourceRow,
            sourceCol,
            MONTH_ROW_COUNT,
            MONTH_COL_COUNT
        );

        if (moveFocus) {
            this.focusCellElement(M, targetRow, targetCol);
        }
    }

    onYearViewBtnClicked(isSecondCalendar?: boolean): void {
        this.selectTime = false;
        if (!isSecondCalendar) {
            this.visibleMonth.year = this.selectedMonth.year;
            if (!this.selectYear) {
                this.generateYears(this.visibleMonth.year, isSecondCalendar);
            } else {
                this.generateCalendar(this.visibleMonth.monthNbr, this.visibleMonth.year, false, isSecondCalendar);
            }

            this.selectYear = this.opts.showType === 3 ? true : !this.selectYear;
            if (this.opts.showType === 2) {
                this.selectMonth = !this.selectMonth;
            } else {
                this.selectMonth = false;
            }
            // this.selectYear = !this.selectYear;
            // this.selectMonth = false;
        } else {
            this.visibleMonth_range.year = this.selectedMonth_range.year;
            if (!this.selectYear_range) {
                this.generateYears(this.visibleMonth_range.year, isSecondCalendar);
            } else {
                this.generateCalendar(this.visibleMonth_range.monthNbr, this.visibleMonth_range.year, false, isSecondCalendar);
            }
            this.selectYear_range = this.opts.showType === 3 ? true : !this.selectYear_range;
            if (this.opts.showType === 2) {
                this.selectMonth_range = !this.selectMonth_range;
            } else {
                this.selectMonth_range = false;
            }
        }
        this.cdr.detectChanges();
    }

    onYearCellClicked(cell: IMyCalendarYear, isSecondCalendar?: boolean): void {
        if (!isSecondCalendar) {
            const { year, monthNbr, monthTxt } = this.visibleMonth;

            const yc: boolean = cell.year !== year;
            this.visibleMonth = { monthTxt, monthNbr, year: cell.year, yearTxt: this.opts.yearTxt };
            this.selectedMonth.year = this.visibleMonth.year;
            this.selectedDate.year = this.visibleMonth.year;
            if (this.opts.showType === 3) {
                this.toSelectYear({ year: this.visibleMonth.year });
            } else if (this.opts.showType === 2) {
                this.generateMonths(isSecondCalendar);
                this.selectYear = false;
                this.selectMonth = true;
            } else {
                // this.generateCalendar(monthNbr, cell.year, yc, isSecondCalendar);
                this.generateMonths(isSecondCalendar);
                this.selectYear = false;
                this.selectMonth = true;
            }
        } else {
            const { year, monthNbr, monthTxt } = this.visibleMonth_range;

            const yc: boolean = cell.year !== year;
            this.visibleMonth_range = {
                monthTxt,
                monthNbr,
                year: cell.year,
                yearTxt: this.opts.yearTxt
            };
            this.selectedMonth_range.year = this.visibleMonth_range.year;
            if (this.opts.showType === 3) {
                this.toSelectYear({ year: this.visibleMonth_range.year });
            } else if (this.opts.showType === 2) {
                this.generateMonths(isSecondCalendar);
                this.selectYear_range = false;
                this.selectMonth_range = true;
            } else {
                this.generateCalendar(monthNbr, cell.year, yc, isSecondCalendar);
                this.selectYear_range = false;
            }
        }
    }

    onYearCellKeyDown(cell: IMyCalendarYear) {
        // Make possible to move focus by arrow keys
        const { sourceRow, sourceCol } = this.getSourceRowAndColumnFromEvent(event);
        const { moveFocus, targetRow, targetCol } = this.getTargetFocusRowAndColumn(
            event,
            sourceRow,
            sourceCol,
            YEAR_ROW_COUNT,
            YEAR_COL_COUNT
        );

        if (moveFocus) {
            this.focusCellElement(Y, targetRow, targetCol);
        }
    }

    generateMonths(isSecondCalendar?: boolean): void {
        const today: IMyDate = this.getToday();
        const { disableUntil, disableSince } = this.opts;

        // tslint:disable-next-line:one-variable-per-declaration
        let year: number, monthNbr: number;
        if (!isSecondCalendar) {
            this.months.length = 0;
            year = this.visibleMonth.year;
            monthNbr = this.visibleMonth.monthNbr;
        } else {
            this.months_range.length = 0;
            year = this.visibleMonth_range.year;
            monthNbr = this.visibleMonth_range.monthNbr;
        }

        for (let i = 1; i <= 12; i += 3) {
            const row: Array<IMyCalendarMonth> = [];
            for (let j = i; j < i + 3; j++) {
                const disabled: boolean =
                    this.utilService.isMonthDisabledByDisableUntil(
                        { year, month: j, day: this.daysInMonth(j, year) },
                        disableUntil
                    ) || this.utilService.isMonthDisabledByDisableSince({ year, month: j, day: 1 }, disableSince);

                row.push({
                    nbr: j,
                    name: this.opts.monthLabels[j],
                    currMonth: j === today.month && year === today.year,
                    disabled,
                    monthObj: { year, month: j }
                });
            }
            if (!isSecondCalendar) {
                this.months.push({ row, year });
            } else {
                this.months_range.push({ row, year });
            }
        }
        this.setMonthViewHeaderBtnDisabledState(year, isSecondCalendar);
        this.generateCalendar(isSecondCalendar? this.visibleMonth_range.monthNbr : this.visibleMonth.monthNbr, year, false, isSecondCalendar);
    }

    generateYears(inputYear: number, isSecondCalendar?: boolean): void {
        const { minYear, maxYear, disableUntil, disableSince } = this.opts;

        let y: number = inputYear - (inputYear % 10);

        const { year, monthNbr } = this.visibleMonth;

        if (!isSecondCalendar) {
            this.years.length = 0;
        } else {
            if (!this.years_range.length && ((this.years&& this.years.length) && y < this.years[3][2].year && y > this.years[0][0].year)  && this.opts.showType === 3) {
                y+= 10;
            }
            this.years_range.length = 0;
            const allYears = flatten<any>(this.years_range);
            if (allYears.findIndex(n => n.year == inputYear) > -1) {
                y = this.years_range[3][2].year;
            }
        }
        const today: IMyDate = this.getToday();

        for (let i = y - 1; i < y + 10; i += 3) {
            const row: Array<IMyCalendarYear> = [];
            for (let j = i; j < i + 3; j++) {
                const disabled: boolean = j < minYear || j > maxYear;
                    // this.utilService.isMonthDisabledByDisableUntil(
                    //     {
                    //         year: j,
                    //         month: monthNbr,
                    //         day: this.daysInMonth(monthNbr, j)
                    //     },
                    //     disableUntil
                    // ) ||
                    // this.utilService.isMonthDisabledByDisableSince({ year: j, month: monthNbr, day: 1 }, disableSince);

                // const minMax: boolean = j < minYear || j > maxYear;
                row.push({
                    year: j,
                    currYear: j === today.year,
                    selected: j === year,
                    disabled,
                    yearObj: { year: j }
                });
            }
            if (!isSecondCalendar) {
                this.years.push(row);
            } else {
                this.years_range.push(row);
            }
        }
        if (!isSecondCalendar) {
            this.setYearViewHeaderBtnDisabledState(this.years[0][1].year, this.years[3][1].year, isSecondCalendar);
        } else {
            this.setYearViewHeaderBtnDisabledState(
                this.years_range[0][1].year,
                this.years_range[3][1].year,
                isSecondCalendar
            );
        }
    }

    setCalendarVisibleMonth(): void {
        // Sets visible month of calendar
        const { year, monthNbr } = this.selectedMonth;
        this.visibleMonth = {
            monthTxt: this.opts.monthLabels[monthNbr],
            monthNbr,
            year,
            yearTxt: this.opts.yearTxt
        };

        // Create current month
        if (this.opts.dateRange) {
            this.visibleMonth_range = {
                monthTxt: this.opts.monthLabels[this.selectedMonth_range.monthNbr],
                monthNbr: this.selectedMonth_range.monthNbr,
                year: this.selectedMonth_range.year,
                yearTxt: this.opts.yearTxt
            };
            this.generateCalendar(this.selectedMonth_range.monthNbr, this.selectedMonth_range.year, true, true);
        }
        this.generateCalendar(monthNbr, year, true, false);
    }

    onPrevNavigateBtnClicked(event?: any, isSecondCalendar?: boolean): void {
        if (!isSecondCalendar) {
            if (event) {
                if (!this.selectMonth && !this.selectYear) {
                    this.setDateViewMonth(isSecondCalendar, false);
                } else if (this.selectMonth) {
                    this.visibleMonth.year--;
                    this.generateMonths(isSecondCalendar);
                } else if (this.selectYear) {
                    this.generateYears(this.years[2][2].year - 10);
                }
            } else {
                if (!this.selectMonth && !this.selectYear) {
                    this.visibleMonth.year--;
                    this.setDateViewMonth(isSecondCalendar);
                } else if (this.selectMonth) {
                    this.visibleMonth.year--;
                    this.generateMonths(isSecondCalendar);
                } else if (this.selectYear) {
                    this.generateYears(this.years[2][2].year - 10, isSecondCalendar);
                }
            }
        } else {
            if (event) {
                if (!this.selectMonth_range && !this.selectYear_range) {
                    this.setDateViewMonth(isSecondCalendar, false);
                } else if (this.selectMonth_range) {
                    this.visibleMonth_range.year--;
                    this.generateMonths(isSecondCalendar);
                } else if (this.selectYear_range) {
                    this.generateYears(this.years_range[2][2].year - 10);
                }
            } else {
                if (!this.selectMonth_range && !this.selectYear_range) {
                    this.visibleMonth_range.year--;
                    this.setDateViewMonth(isSecondCalendar);
                } else if (this.selectMonth_range) {
                    this.visibleMonth_range.year--;
                    this.generateMonths(isSecondCalendar);
                } else if (this.selectYear_range) {
                    this.generateYears(this.years_range[2][2].year - 10, isSecondCalendar);
                }
            }
        }
    }

    onNextNavigateBtnClicked(event?: any, isSecondCalendar?: boolean): void {
        if (!isSecondCalendar) {
            if (event) {
                if (!this.selectMonth && !this.selectYear) {
                    this.setDateViewMonth(isSecondCalendar, true);
                } else if (this.selectMonth) {
                    this.visibleMonth.year++;
                    this.generateMonths();
                } else if (this.selectYear) {
                    this.generateYears(this.years[2][2].year + 10);
                }
            } else {
                if (!this.selectMonth && !this.selectYear) {
                    this.visibleMonth.year++;
                    this.setDateViewMonth(isSecondCalendar);
                } else if (this.selectMonth) {
                    this.visibleMonth.year++;
                    this.generateMonths();
                } else if (this.selectYear) {
                    this.generateYears(this.years[2][2].year + 10);
                }
            }
        } else {
            if (event) {
                if (!this.selectMonth_range && !this.selectYear_range) {
                    this.setDateViewMonth(isSecondCalendar, true);
                } else if (this.selectMonth_range) {
                    this.visibleMonth_range.year++;
                    this.generateMonths(isSecondCalendar);
                } else if (this.selectYear_range) {
                    this.generateYears(this.years_range[2][2].year + 10, isSecondCalendar);
                }
            } else {
                if (!this.selectMonth_range && !this.selectYear_range) {
                    this.visibleMonth_range.year++;
                    this.setDateViewMonth(isSecondCalendar);
                } else if (this.selectMonth_range) {
                    this.visibleMonth_range.year++;
                    this.generateMonths(isSecondCalendar);
                } else if (this.selectYear_range) {
                    this.generateYears(this.years_range[2][2].year + 10, isSecondCalendar);
                }
            }
        }
    }

    setDateViewMonth(isSecondCalendar?: boolean, isNext?: boolean): void {
        let change: number;
        if (isNext === undefined) {
            change = 0;
        } else {
            change = isNext ? 1 : -1;
        }
        if (!isSecondCalendar) {
            const { year, monthNbr } = this.visibleMonth;

            const d: Date = this.getDate(year, monthNbr, 1);
            d.setMonth(d.getMonth() + change);

            const y: number = d.getFullYear();
            const m: number = d.getMonth() + 1;

            this.visibleMonth = {
                monthTxt: this.opts.monthLabels[m],
                monthNbr: m,
                year: y,
                yearTxt: this.opts.yearTxt
            };
            this.generateCalendar(m, y, true, isSecondCalendar);
        } else {
            const { year, monthNbr } = this.visibleMonth_range;

            const d: Date = this.getDate(year, monthNbr, 1);
            d.setMonth(d.getMonth() + change);

            const y: number = d.getFullYear();
            const m: number = d.getMonth() + 1;

            this.visibleMonth_range = {
                monthTxt: this.opts.monthLabels[m],
                monthNbr: m,
                year: y,
                yearTxt: this.opts.yearTxt
            };
            this.generateCalendar(m, y, true, isSecondCalendar);
        }
    }

    onCloseSelector(event: any): void {
        const keyCode: number = this.utilService.getKeyCodeFromEvent(event);
        if (keyCode === KeyCode.esc) {
            this.closedByEsc();
        }
    }

    onDayCellClicked(cell: IMyCalendarDay, isSecondCalendar?: boolean): void {
        if (cell.cmo === 1) {
            this.onPrevNavigateBtnClicked(true, isSecondCalendar);
        } else if (cell.cmo === 3) {
            this.onNextNavigateBtnClicked(true, isSecondCalendar);
        }
        this.selectDate(cell.dateObj);
        this.resetMonthYearSelect(isSecondCalendar);
    }

    onDayCellKeyDown(cell: IMyCalendarDay) {
        // Make possible to move focus by arrow keys
        const { sourceRow, sourceCol } = this.getSourceRowAndColumnFromEvent(event);
        const { moveFocus, targetRow, targetCol } = this.getTargetFocusRowAndColumn(
            event,
            sourceRow,
            sourceCol,
            DATE_ROW_COUNT,
            DATE_COL_COUNT
        );

        if (moveFocus) {
            this.focusCellElement(D, targetRow, targetCol);
        }
    }
    onDayCellMouseEnter(cell: any, isSecondCalendar?: boolean) {
        if (isSecondCalendar) {
            for (const w of this.dates) {
                for (const day of w.week) {
                    day.range =
                        (this.utilService.isDateSameOrEarlier(this.selectedDateRange.begin, day.dateObj) &&
                            this.utilService.isDateSameOrEarlier(day.dateObj, cell.dateObj)) ||
                        (this.utilService.isDateSameOrEarlier(day.dateObj, this.selectedDateRange.begin) &&
                            this.utilService.isDateSameOrEarlier(cell.dateObj, day.dateObj));
                }
            }
        } else {
            for (const w of this.dates_range) {
                for (const day of w.week) {
                    day.range =
                        (this.utilService.isDateSameOrEarlier(this.selectedDateRange.begin, day.dateObj) &&
                            this.utilService.isDateSameOrEarlier(day.dateObj, cell.dateObj)) ||
                        (this.utilService.isDateSameOrEarlier(day.dateObj, this.selectedDateRange.begin) &&
                            this.utilService.isDateSameOrEarlier(cell.dateObj, day.dateObj));
                }
            }
        }
    }
    onDayCellMouseLeave(isSecondCalendar?: boolean) {
        if (isSecondCalendar) {
            for (const w of this.dates) {
                for (const day of w.week) {
                    day.range = false;
                }
            }
        } else {
            for (const w of this.dates_range) {
                for (const day of w.week) {
                    day.range = false;
                }
            }
        }
    }
    onMonthCellMouseEnter(cell: any, isSecondCalendar?: boolean) {
        if (isSecondCalendar) {
            for (const item of this.months) {
                for (const month of item.row) {
                    month.range =
                        (this.utilService.isDateSameOrEarlier(this.selectedDateRange.begin, month.monthObj) &&
                            this.utilService.isDateSameOrEarlier(month.monthObj, cell.monthObj)) ||
                        (this.utilService.isDateSameOrEarlier(month.monthObj, this.selectedDateRange.begin) &&
                            this.utilService.isDateSameOrEarlier(cell.monthObj, month.monthObj));
                }
            }
        } else {
            for (const item of this.months_range) {
                for (const month of item.row) {
                    month.range =
                        (this.utilService.isDateSameOrEarlier(this.selectedDateRange.begin, month.monthObj) &&
                            this.utilService.isDateSameOrEarlier(month.monthObj, cell.monthObj)) ||
                        (this.utilService.isDateSameOrEarlier(month.monthObj, this.selectedDateRange.begin) &&
                            this.utilService.isDateSameOrEarlier(cell.monthObj, month.monthObj));
                }
            }
        }
    }
    onMonthCellMouseLeave(isSecondCalendar?: boolean) {
        if (isSecondCalendar) {
            for (const item of this.months) {
                for (const month of item.row) {
                    month.range = false;
                }
            }
        } else {
            for (const item of this.months) {
                for (const month of item.row) {
                    month.range = false;
                }
            }
        }
    }
    onYearCellMouseEnter(cell: any, isSecondCalendar?: boolean) {
        if (isSecondCalendar) {
            for (const item of this.years) {
                for (const year of item) {
                    year.range =
                        (this.utilService.isDateSameOrEarlier(this.selectedDateRange.begin, year.yearObj) &&
                            this.utilService.isDateSameOrEarlier(year.yearObj, cell.yearObj)) ||
                        (this.utilService.isDateSameOrEarlier(year.yearObj, this.selectedDateRange.begin) &&
                            this.utilService.isDateSameOrEarlier(cell.yearObj, year.yearObj));
                }
            }
        } else {
            for (const item of this.years_range) {
                for (const year of item) {
                    year.range =
                        (this.utilService.isDateSameOrEarlier(this.selectedDateRange.begin, year.yearObj) &&
                            this.utilService.isDateSameOrEarlier(year.yearObj, cell.yearObj)) ||
                        (this.utilService.isDateSameOrEarlier(year.yearObj, this.selectedDateRange.begin) &&
                            this.utilService.isDateSameOrEarlier(cell.yearObj, year.yearObj));
                }
            }
        }
    }
    onYearCellMouseLeave(isSecondCalendar?: boolean) {
        if (isSecondCalendar) {
            for (const item of this.years) {
                for (const year of item) {
                    year.range = false;
                }
            }
        } else {
            for (const item of this.years_range) {
                for (const year of item) {
                    year.range = false;
                }
            }
        }
    }
    onWeekClicked(weekData: IMyWeek) {
        const showTime = this.opts.returnFormat && this.opts.returnFormat.toLocaleLowerCase().indexOf('hh:mm') > -1;
        this.selectedWeek = { weekNbr: weekData.weekNbr, year: weekData.year };

        if (showTime) {
            weekData.week[0].dateObj.hour = 0;
            weekData.week[0].dateObj.minute = 0;
            weekData.week[0].dateObj.second = 0;

            weekData.week[6].dateObj.hour = 23;
            weekData.week[6].dateObj.minute = 59;
            weekData.week[6].dateObj.second = 59;
        }

        this.selectDate(weekData.week[0].dateObj);
        this.selectDate(weekData.week[6].dateObj);
    }
    getSourceRowAndColumnFromEvent(event: any): any {
        let sourceRow = 0;
        let sourceCol = 0;
        if (event.target && event.target.id) {
            // value of id is for example: m_0_1 (first number = row, second number = column)
            const arr: Array<string> = event.target.id.split(UNDER_LINE);
            sourceRow = Number(arr[1]);
            sourceCol = Number(arr[2]);
        }
        return { sourceRow, sourceCol };
    }

    getTargetFocusRowAndColumn(event: any, row: number, col: number, rowCount: number, colCount: number): any {
        let moveFocus = false;
        let targetRow: number = row;
        let targetCol: number = col;

        const keyCode: number = this.utilService.getKeyCodeFromEvent(event);
        if (keyCode === KeyCode.upArrow && row > 0) {
            moveFocus = true;
            targetRow--;
        } else if (keyCode === KeyCode.downArrow && row < rowCount) {
            moveFocus = true;
            targetRow++;
        } else if (keyCode === KeyCode.leftArrow && col > 0) {
            moveFocus = true;
            targetCol--;
        } else if (keyCode === KeyCode.rightArrow && col < colCount) {
            moveFocus = true;
            targetCol++;
        }
        return { moveFocus, targetRow, targetCol };
    }

    focusCellElement(type: string, row: number, col: number): void {
        const elem: any = this.selectorEl.nativeElement.querySelector(DOT + type + UNDER_LINE + row + UNDER_LINE + col);
        if (elem) {
            elem.focus();
        }
    }

    selectDate(date: IMyDate): void {
        const { dateFormat, monthLabels, dateRangeDatesDelimiter, closeSelectorOnDateSelect, showTime, returnFormat } = this.opts;

        if (this.opts.dateRange) {
            // Date range
            const isBeginDateInitialized: boolean = this.utilService.isInitializedDate(this.selectedDateRange.begin);
            const isEndDateInitialized: boolean = this.utilService.isInitializedDate(this.selectedDateRange.end) &&
                JSON.stringify(this.selectedDateRange.begin) !== JSON.stringify(this.selectedDateRange.end);

            if (isBeginDateInitialized && isEndDateInitialized) {
                // both already selected - set begin date and reset end date
                this.selectedDateRange.begin = date;
                this.selectedDateRange.end = this.utilService.resetDate();

                this.rangeDateSelection({
                    isBegin: true,
                    date,
                    jsDate: this.utilService.getDate(date),
                    dateFormat,
                    formatted: this.utilService.formatDate(date, dateFormat, monthLabels),
                    epoc: this.utilService.getEpocTime(date)
                });
            } else if (!isBeginDateInitialized) {
                // begin date
                this.selectedDateRange.begin = date;
                if (!isEndDateInitialized) {
                    this.selectedDateRange.end = date;
                }
                this.rangeDateSelection({
                    isBegin: true,
                    date,
                    jsDate: this.utilService.getDate(date),
                    dateFormat,
                    formatted: this.utilService.formatDate(date, dateFormat, monthLabels),
                    epoc: this.utilService.getEpocTime(date)
                });
            } else {
                // second selection
                const firstDateEarlier: boolean = this.utilService.isDateEarlier(date, this.selectedDateRange.begin);
                if (firstDateEarlier) {
                    const _date = this.selectedDateRange.begin;
                    this.selectedDateRange.end = _date;
                    this.rangeDateSelection({
                        isBegin: false,
                        date: _date,
                        jsDate: this.utilService.getDate(_date),
                        dateFormat,
                        formatted: this.utilService.formatDate(_date, dateFormat, monthLabels),
                        epoc: this.utilService.getEpocTime(_date)
                    });
                    this.selectedDateRange.begin = date;
                    this.rangeDateSelection({
                        isBegin: true,
                        date,
                        jsDate: this.utilService.getDate(date),
                        dateFormat,
                        formatted: this.utilService.formatDate(date, dateFormat, monthLabels),
                        epoc: this.utilService.getEpocTime(date)
                    });
                } else {
                    this.selectedDateRange.end = date;
                    this.rangeDateSelection({
                        isBegin: false,
                        date,
                        jsDate: this.utilService.getDate(date),
                        dateFormat,
                        formatted: this.utilService.formatDate(date, dateFormat, monthLabels),
                        epoc: this.utilService.getEpocTime(date)
                    });
                }
                if (!this.opts.showTime) {
                    this.dateChanged(
                        this.utilService.getDateModel(
                            null,
                            this.selectedDateRange,
                            dateFormat,
                            monthLabels,
                            dateRangeDatesDelimiter,
                            returnFormat
                        ),
                        closeSelectorOnDateSelect
                    );
                }
            }
        } else {
            // Single date
            this.selectedDate = date;
            this.selectedMonth.year = this.selectedDate.year; // tfs 638302 638296

            if (!this.opts.showTime) {
                this.dateChanged(
                    this.utilService.getDateModel(
                        this.selectedDate,
                        null,
                        dateFormat,
                        monthLabels,
                        dateRangeDatesDelimiter,
                        returnFormat
                    ),
                    showTime ? false : closeSelectorOnDateSelect
                );
            } else {
                if (!this.timeVlaue && this.opts.viewType == ViewType.Together) {
                    this.timeVlaue = this.getTimeStr(new Date);
                }
            }
        }
    }
    toSelectMonth(month: IMyMonth): void {
        const { dateFormat, monthLabels, dateRangeDatesDelimiter, closeSelectorOnDateSelect, showTime, returnFormat } = this.opts;
        if (this.opts.dateRange) {
            // month range
            const isBeginMonthInitialized: boolean = this.utilService.isInitializedMonth(this.selectedDateRange.begin);
            const isEndMonthInitialized: boolean = this.utilService.isInitializedMonth(this.selectedDateRange.end);
            if (isBeginMonthInitialized && isEndMonthInitialized) {
                // both already selected - set begin date and reset end date
                this.selectedDateRange.begin = { year: month.year, month: month.monthNbr };
                this.selectedDateRange.end = this.utilService.resetDate();
                this.rangeDateSelection({
                    isBegin: true,
                    date: this.selectedDateRange.begin,
                    jsDate: this.utilService.getDate(this.selectedDateRange.begin),
                    dateFormat,
                    formatted: this.utilService.formatDate(this.selectedDateRange.begin, dateFormat, monthLabels),
                    epoc: this.utilService.getEpocTime(this.selectedDateRange.begin)
                });
            } else if (!isBeginMonthInitialized) {
                // begin date
                this.selectedDateRange.begin = { year: month.year, month: month.monthNbr };
                this.rangeDateSelection({
                    isBegin: true,
                    date: this.selectedDateRange.begin,
                    jsDate: this.utilService.getDate(this.selectedDateRange.begin),
                    dateFormat,
                    formatted: this.utilService.formatDate(this.selectedDateRange.begin, dateFormat, monthLabels),
                    epoc: this.utilService.getEpocTime(this.selectedDateRange.begin)
                });
            } else {
                // second selection
                const firstDateEarlier: boolean = this.utilService.isDateEarlier(
                    { year: month.year, month: month.monthNbr },
                    this.selectedDateRange.begin
                );
                if (firstDateEarlier) {
                    const _date = this.selectedDateRange.begin;
                    this.selectedDateRange.end = _date;
                    this.rangeDateSelection({
                        isBegin: false,
                        date: _date,
                        jsDate: this.utilService.getDate(_date),
                        dateFormat,
                        formatted: this.utilService.formatDate(_date, dateFormat, monthLabels),
                        epoc: this.utilService.getEpocTime(_date)
                    });
                    this.selectedDateRange.begin = { year: month.year, month: month.monthNbr };
                    this.rangeDateSelection({
                        isBegin: true,
                        date: this.selectedDateRange.begin,
                        jsDate: this.utilService.getDate(this.selectedDateRange.begin),
                        dateFormat,
                        formatted: this.utilService.formatDate(this.selectedDateRange.begin, dateFormat, monthLabels),
                        epoc: this.utilService.getEpocTime(this.selectedDateRange.begin)
                    });
                } else {
                    this.selectedDateRange.end = { year: month.year, month: month.monthNbr };
                    this.rangeDateSelection({
                        isBegin: false,
                        date: this.selectedDateRange.end,
                        jsDate: this.utilService.getDate(this.selectedDateRange.end),
                        dateFormat,
                        formatted: this.utilService.formatDate(this.selectedDateRange.end, dateFormat, monthLabels),
                        epoc: this.utilService.getEpocTime(this.selectedDateRange.end)
                    });
                }
                if (!this.opts.showTime) {
                    this.dateChanged(
                        this.utilService.getDateModel(
                            null,
                            this.selectedDateRange,
                            dateFormat,
                            monthLabels,
                            dateRangeDatesDelimiter,
                            returnFormat
                        ),
                        closeSelectorOnDateSelect
                    );
                }
            }
        } else {
            this.selectedMonth = month;
            this.dateChanged(
                this.utilService.getDateModel(
                    { year: month.year, month: month.monthNbr },
                    null,
                    dateFormat,
                    monthLabels,
                    dateRangeDatesDelimiter,
                    returnFormat
                ),
                showTime ? false : closeSelectorOnDateSelect
            );
        }
    }
    toSelectYear(year: { year: number }): void {
        const { dateFormat, monthLabels, dateRangeDatesDelimiter, closeSelectorOnDateSelect, showTime, returnFormat } = this.opts;
        if (this.opts.dateRange) {
            // month range
            const isBeginYearInitialized: boolean = this.utilService.isInitializedYear(this.selectedDateRange.begin);
            const isEndYearInitialized: boolean = this.utilService.isInitializedYear(this.selectedDateRange.end);
            if (isBeginYearInitialized && isEndYearInitialized) {
                // both already selected - set begin date and reset end date
                this.selectedDateRange.begin = year;
                this.selectedDateRange.end = this.utilService.resetDate();
                this.rangeDateSelection({
                    isBegin: true,
                    date: this.selectedDateRange.begin,
                    jsDate: this.utilService.getDate(this.selectedDateRange.begin),
                    dateFormat,
                    formatted: this.utilService.formatDate(this.selectedDateRange.begin, dateFormat, monthLabels),
                    epoc: this.utilService.getEpocTime(this.selectedDateRange.begin)
                });
            } else if (!isBeginYearInitialized) {
                // begin date
                this.selectedDateRange.begin = year;
                this.rangeDateSelection({
                    isBegin: true,
                    date: this.selectedDateRange.begin,
                    jsDate: this.utilService.getDate(this.selectedDateRange.begin),
                    dateFormat,
                    formatted: this.utilService.formatDate(this.selectedDateRange.begin, dateFormat, monthLabels),
                    epoc: this.utilService.getEpocTime(this.selectedDateRange.begin)
                });
            } else {
                // second selection
                const firstDateEarlier: boolean = this.utilService.isDateEarlier(year, this.selectedDateRange.begin);
                if (firstDateEarlier) {
                    const _date = this.selectedDateRange.begin;
                    this.selectedDateRange.end = _date;
                    this.rangeDateSelection({
                        isBegin: false,
                        date: _date,
                        jsDate: this.utilService.getDate(_date),
                        dateFormat,
                        formatted: this.utilService.formatDate(_date, dateFormat, monthLabels),
                        epoc: this.utilService.getEpocTime(_date)
                    });
                    this.selectedDateRange.begin = year;
                    this.rangeDateSelection({
                        isBegin: true,
                        date: this.selectedDateRange.begin,
                        jsDate: this.utilService.getDate(this.selectedDateRange.begin),
                        dateFormat,
                        formatted: this.utilService.formatDate(this.selectedDateRange.begin, dateFormat, monthLabels),
                        epoc: this.utilService.getEpocTime(this.selectedDateRange.begin)
                    });
                } else {
                    this.selectedDateRange.end = year;
                    this.rangeDateSelection({
                        isBegin: false,
                        date: this.selectedDateRange.end,
                        jsDate: this.utilService.getDate(this.selectedDateRange.end),
                        dateFormat,
                        formatted: this.utilService.formatDate(this.selectedDateRange.end, dateFormat, monthLabels),
                        epoc: this.utilService.getEpocTime(this.selectedDateRange.end)
                    });
                }
                if (!this.opts.showTime) {
                    this.dateChanged(
                        this.utilService.getDateModel(
                            null,
                            this.selectedDateRange,
                            dateFormat,
                            monthLabels,
                            dateRangeDatesDelimiter,
                            returnFormat
                        ),
                        closeSelectorOnDateSelect
                    );
                }
            }
        } else {
            this.dateChanged(
                this.utilService.getDateModel(year, null, dateFormat, monthLabels, dateRangeDatesDelimiter, returnFormat),
                showTime ? false : closeSelectorOnDateSelect
            );
        }
    }
    monthStartIdx(y: number, m: number): number {
        // Month start index
        const d: Date = new Date();
        d.setDate(1);
        d.setMonth(m - 1);
        d.setFullYear(y);
        const idx = d.getDay() + this.sundayIdx();
        return idx >= 7 ? idx - 7 : idx;
    }

    daysInMonth(m: number, y: number): number {
        // Return number of days of current month
        return new Date(y, m, 0).getDate();
    }

    daysInPrevMonth(m: number, y: number): number {
        // Return number of days of the previous month
        const d: Date = this.getDate(y, m, 1);
        d.setMonth(d.getMonth() - 1);
        return this.daysInMonth(d.getMonth() + 1, d.getFullYear());
    }

    isCurrDay(d: number, m: number, y: number, cmo: number, today: IMyDate): boolean {
        // Check is a given date the today
        return d === today.day && m === today.month && y === today.year && cmo === MonthId.curr;
    }

    getWidth() {
        const hasShortCuts = this.opts.shortcuts && this.opts.shortcuts.length > 0;
        if (this.opts.dateRange && this.opts.showType !== 4) {
            return hasShortCuts ? '660px' : '574px';
        } else {
            const w =  (hasShortCuts ? 380 : 287) + ((this.opts.viewType === ViewType.Together || this.multiSelect) ? 200 : 0);
            return w + 'px';
        }
    }

    getToday(): IMyDate {
        const date: Date = new Date();
        if (this.opts.showTime) {
            return {
                year: date.getFullYear(),
                month: date.getMonth() + 1,
                day: date.getDate(),
                hour: date.getHours(),
                minute: date.getMinutes(),
                second: date.getSeconds()
            };
        } else {
            return { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
        }
    }

    getDayNumber(date: IMyDate): number {
        // Get day number: su=0, mo=1, tu=2, we=3 ...
        const d: Date = this.getDate(date.year, date.month, date.day);
        return d.getDay();
    }

    getWeekday(date: IMyDate): string {
        // Get weekday: su, mo, tu, we ...
        return this.weekDayOpts[this.getDayNumber(date)];
    }

    getDate(year: number, month: number, day: number): Date {
        // Creates a date object from given year, month and day
        return new Date(year, month - 1, day, 0, 0, 0, 0);
    }

    sundayIdx(): number {
        // Index of Sunday day
        return this.dayIdx > 0 ? 7 - this.dayIdx : 0;
    }

    generateCalendar(m: number, y: number, notifyChange: boolean, isSecondCalendar?: boolean): void {
        if (!isSecondCalendar) {
            this.dates.length = 0;
        } else {
            this.dates_range.length = 0;
        }
        const today: IMyDate = this.getToday();
        const monthStart: number = this.monthStartIdx(y, m);
        const dInThisM: number = this.daysInMonth(m, y);
        const dInPrevM: number = this.daysInPrevMonth(m, y);

        let dayNbr = 1;
        let cmo: number = MonthId.prev;
        for (let i = 1; i < 7; i++) {
            const week: Array<IMyCalendarDay> = [];
            if (i === 1) {
                // First week
                const pm = dInPrevM - monthStart + 1;
                // Previous month
                for (let j = pm; j <= dInPrevM; j++) {
                    const date: IMyDate = { year: m === 1 ? y - 1 : y, month: m === 1 ? 12 : m - 1, day: j };
                    week.push({
                        dateObj: date,
                        cmo,
                        currDay: this.isCurrDay(j, m, y, cmo, today),
                        disabled: this.utilService.isDisabledDate(date, this.opts),
                        markedDate: this.utilService.isMarkedDate(date, this.opts.markDates, this.opts.markWeekends),
                        highlight: this.utilService.isHighlightedDate(
                            date,
                            this.opts.sunHighlight,
                            this.opts.satHighlight,
                            this.opts.highlightDates
                        )
                    });
                }

                cmo = MonthId.curr;
                // Current month
                const daysLeft: number = 7 - week.length;
                for (let j = 0; j < daysLeft; j++) {
                    const date: IMyDate = { year: y, month: m, day: dayNbr };
                    week.push({
                        dateObj: date,
                        cmo,
                        currDay: this.isCurrDay(dayNbr, m, y, cmo, today),
                        disabled: this.utilService.isDisabledDate(date, this.opts),
                        markedDate: this.utilService.isMarkedDate(date, this.opts.markDates, this.opts.markWeekends),
                        highlight: this.utilService.isHighlightedDate(
                            date,
                            this.opts.sunHighlight,
                            this.opts.satHighlight,
                            this.opts.highlightDates
                        )
                    });
                    dayNbr++;
                }
            } else {
                // Rest of the weeks
                for (let j = 1; j < 8; j++) {
                    if (dayNbr > dInThisM) {
                        // Next month
                        dayNbr = 1;
                        cmo = MonthId.next;
                    }
                    const date: IMyDate = {
                        year: cmo === MonthId.next && m === 12 ? y + 1 : y,
                        month: cmo === MonthId.curr ? m : cmo === MonthId.next && m < 12 ? m + 1 : 1,
                        day: dayNbr
                    };
                    week.push({
                        dateObj: date,
                        cmo,
                        currDay: this.isCurrDay(dayNbr, m, y, cmo, today),
                        disabled: this.utilService.isDisabledDate(date, this.opts),
                        markedDate: this.utilService.isMarkedDate(date, this.opts.markDates, this.opts.markWeekends),
                        highlight: this.utilService.isHighlightedDate(
                            date,
                            this.opts.sunHighlight,
                            this.opts.satHighlight,
                            this.opts.highlightDates
                        )
                    });
                    dayNbr++;
                }
            }

            // let weekNbr = this.opts.showWeekNumbers ? this.utilService.getWeekNumber(week[0].dateObj) : 0;
            let weekNbr = 0;
            if (this.opts.showWeekNumbers ) {
                const dateIndex = this.opts.firstDayOfWeek == 'su' ? 6: 0
           
                weekNbr = this.utilService.getWeekNumber(week[dateIndex].dateObj);
                // if (this.opts.firstDayOfWeek === 'su') {
                //     endDayWeekNbr -= 1;
                // }
                // weekNbr = this.utilService.getWeekNumber(week[0].dateObj) === endDayWeekNbr ? this.utilService.getWeekNumber(week[0].dateObj): 0;
            }



            if (!isSecondCalendar) {
                this.dates.push({ week, weekNbr, year: y });
            } else {
                this.dates_range.push({ week, weekNbr, year: y });
            }
        }

        this.setDateViewHeaderBtnDisabledState(m, y, isSecondCalendar);

        if (notifyChange) {
            // Notify parent
            this.calendarViewChanged({
                year: y,
                month: m,
                first: { number: 1, weekday: this.getWeekday({ year: y, month: m, day: 1 }) },
                last: { number: dInThisM, weekday: this.getWeekday({ year: y, month: m, day: dInThisM }) }
            });
        }
    }

    setDateViewHeaderBtnDisabledState(m: number, y: number, isSecondCalendar: boolean): void {
        let dpm = false;
        let dnm = false;

        const { disableUntil, disableSince, minYear, maxYear } = this.opts;

        dpm = this.utilService.isMonthDisabledByDisableUntil(
            {
                year: m === 1 ? y - 1 : y,
                month: m === 1 ? 12 : m - 1,
                day: this.daysInMonth(m === 1 ? 12 : m - 1, m === 1 ? y - 1 : y)
            },
            disableUntil
        );
        dnm = this.utilService.isMonthDisabledByDisableSince(
            { year: m === 12 ? y + 1 : y, month: m === 12 ? 1 : m + 1, day: 1 },
            disableSince
        );
        if (!isSecondCalendar) {
            this.prevViewDisabled = (m === 1 && y === minYear) || dpm;
            this.nextViewDisabled = (m === 12 && y === maxYear) || dnm;
            this.prevDobViewDisabled = y === minYear || dpm;
            this.nextDobViewDisabled = y === maxYear || dnm;
        } else {
            this.prevViewDisabled_range = (m === 1 && y === minYear) || dpm;
            this.nextViewDisabled_range = (m === 12 && y === maxYear) || dnm;
            this.prevDobViewDisabled_range = y === minYear || dpm;
            this.nextDobViewDisabled_range = y === maxYear || dnm;
        }
    }

    setMonthViewHeaderBtnDisabledState(y: number, isSecondCalendar: boolean): void {
        let dpm = false;
        let dnm = false;

        const { disableUntil, disableSince, minYear, maxYear } = this.opts;

        dpm = this.utilService.isMonthDisabledByDisableUntil({ year: y - 1, month: 12, day: 31 }, disableUntil);
        dnm = this.utilService.isMonthDisabledByDisableSince({ year: y + 1, month: 1, day: 1 }, disableSince);
        if (!isSecondCalendar) {
            this.prevViewDisabled = y === minYear || dpm;
            this.nextViewDisabled = y === maxYear || dnm;
            this.prevDobViewDisabled = y === minYear || dpm;
            this.nextDobViewDisabled = y === maxYear || dnm;
        } else {
            this.prevViewDisabled_range = y === minYear || dpm;
            this.nextViewDisabled_range = y === maxYear || dnm;
            this.prevDobViewDisabled_range = y === minYear || dpm;
            this.nextDobViewDisabled_range = y === maxYear || dnm;
        }
    }

    setYearViewHeaderBtnDisabledState(yp: number, yn: number, isSecondCalendar: boolean): void {
        let dpy = false;
        let dny = false;

        const { disableUntil, disableSince, minYear, maxYear } = this.opts;

        dpy = this.utilService.isMonthDisabledByDisableUntil({ year: yp - 1, month: 12, day: 31 }, disableUntil);
        dny = this.utilService.isMonthDisabledByDisableSince({ year: yn + 1, month: 1, day: 1 }, disableSince);
        if (!isSecondCalendar) {
            this.prevViewDisabled = yp <= minYear || dpy;
            this.nextViewDisabled = yn >= maxYear || dny;
            this.prevDobViewDisabled = yp <= minYear || dpy;
            this.nextDobViewDisabled = yn >= maxYear || dny;
        } else {
            this.prevViewDisabled_range = yp <= minYear || dpy;
            this.nextViewDisabled_range = yn >= maxYear || dny;
            this.prevDobViewDisabled_range = yp <= minYear || dpy;
            this.nextDobViewDisabled_range = yn >= maxYear || dny;
        }
    }
    onContainerClick(event: Event) {
        event.stopPropagation();
    }
    onClickTimeBtn(event: Event) {
        event.stopPropagation();
        if (this.opts.dateRange) {
            const beginIsInitializedDate = this.utilService.isInitializedDate(this.selectedDateRange.begin);
            const endIsInitializedDate = this.utilService.isInitializedDate(this.selectedDateRange.end);
            const now = new Date();
            if (!beginIsInitializedDate || !endIsInitializedDate) {
                // ç´æ¥ç¹å»ç¡®å®æ¾ç¤ºæ¬æåä¸æ
                if (!beginIsInitializedDate) {
                    this.selectedDateRange.begin = { year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate() };
                }
                let endYear = now.getFullYear();
                let endmonth = now.getMonth() + 1;
                if (endmonth >= 12) {
                    endYear = endYear + 1;
                    endmonth = 1;
                }
                // else {
                //     endmonth = endmonth + this.opts.monthRangeValue;
                // }
                this.selectedDateRange.end = { ...this.selectedDateRange.begin };
                // this.selectedDateRange.end = { year: endYear, month: endmonth, day: now.getDate() };
                // ç¹å»selectTimeä¹åç»dateRangeèµä¸¤ä¸ªæ¶é´å¼
                this.timeVlaue = this.getTimeStr(now);
                this.timeVlaue_range = this.getTimeStr(now);
            }

            if (!this.timeVlaue_range) {
                this.timeVlaue_range = this.getTimeStr(now);
            }
            
            this.timeVlaue_range = this.checkTimeValues(this.timeVlaue_range);

        } else {
            if (!this.utilService.isInitializedDate(this.selectedDate)) {
                const now = new Date();
                // ç¹å»selectTimeä¹åèµå¼
                this.timeVlaue = this.getTimeStr(now);
                this.selectedDate = { year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate() };
            }
        }

        
        if (!this.timeVlaue) {
            const now = new Date();
            // ç¹å»selectTimeä¹åèµå¼
            this.timeVlaue = this.getTimeStr(now);
            if (!this.utilService.isInitializedDate(this.selectedDate)) {
                this.selectedDate = { year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate() };
            }
        }

        this.timeVlaue = this.checkTimeValues(this.timeVlaue);

        if (this.selectYear) {
            this.selectYear = false;
        }
        if (this.selectMonth) {
            this.selectMonth = false;
        }

        if (this.selectYear_range) {
            this.selectYear_range = false;
        }

        if (this.selectMonth_range) {
            this.selectMonth_range = false;
        }

        this.selectTime = !this.selectTime;
        this.cdr.detectChanges();
    }

    onShowDynamicView($event) {
        $event.stopPropagation();
        this.opts.showDynamicView = true;
        this.dynamicViewShow.emit( { showDynamicView: true } );
        this.cdr.detectChanges();
    }

    onShowDatePanel($event) {
        $event.stopPropagation();
        this.opts.showDynamicView = false;
        this.dynamicViewShow.emit( { showDynamicView: false } );
        this.cdr.detectChanges();
    }


    private getTimeValue(isDateRange) {
        const t = { start: null, end: null };
        if (this.timeVlaue) {
            const timeArr = this.timeVlaue.replace('æ¶', ':').replace('å', ':').replace('ç§', '').split(':');
            if (timeArr.length >= 2) {
                t.start = {
                    hour: timeArr[0],
                    minute: timeArr[1],
                    second: timeArr[2] ? timeArr[2] : 0
                };
            }
        } else {
            const nowDate = new Date();
            const hour = nowDate.getHours();
            const minute = nowDate.getMinutes();
            const second = nowDate.getSeconds();

            if (this.opts.dateRange) {
                t.start = { hour: 0, minute: 0, second: 0 };
            } else {
                t.start = { hour, minute, second };
            }
        }

        if (isDateRange) {
            if (this.timeVlaue_range) {
                const timeArr_range = this.timeVlaue_range.replace('æ¶', ':').replace('å', ':').replace('ç§', '').split(':');
                if (timeArr_range.length >= 2) {
                    t.end = {
                        hour: timeArr_range[0],
                        minute: timeArr_range[1],
                        second: timeArr_range[2] ? timeArr_range[2] : 0
                    };
                }
            } else {
                const hour = 23;
                const minute = 59;
                const second = 59;
                t.end = { hour, minute, second };
            }
        }

        return t;
    }


    onClickOkBtn(event: Event) {
        event.stopPropagation();
        let timeObj = null;
        let timeObj_range = null;
        let selectedDate = null;
        let selectedDate_range = null;
        if (this.opts.showTime) {
            const { start, end } = this.getTimeValue(this.opts.dateRange);
            timeObj = start;
            timeObj_range = end;
        }
        const { dateFormat, monthLabels, dateRangeDatesDelimiter, closeSelectorOnDateSelect, returnFormat } = this.opts;
        if (!this.opts.dateRange) {
            selectedDate = { ...this.initializedDate(this.selectedDate), ...timeObj };
            const isInDisableRange = this.utilService.isDisabledDate(selectedDate, this.opts);
            const earlier = this.utilService.isDateSameOrEarlier(selectedDate, this.opts.disableUntil);

            selectedDate = !isInDisableRange
                ? selectedDate
                : { ...selectedDate, ...(earlier ? this.opts.disableUntil : this.opts.disableSince) };
            
            this.checkTimeValue(selectedDate);
        } else {
            const begin = { ...this.initializedDate(this.selectedDateRange.begin), ...timeObj };
            
            const { year, month, day } =this.selectedDateRange.end;
            if (!year ||!month ||!day) {
                this.selectedDateRange.end = {...this.selectedDateRange.begin };
            }

            const end = { ...this.initializedDate(this.selectedDateRange.end, begin), ...timeObj_range };
            this.checkTimeValue(begin);
            this.checkTimeValue(end);
            selectedDate_range = { begin, end };
        }

        const dateModel: IMyDateModel = this.utilService.getDateModel(
            selectedDate,
            selectedDate_range,
            dateFormat,
            monthLabels,
            dateRangeDatesDelimiter,
            returnFormat
        );
        this.dateChanged(dateModel, closeSelectorOnDateSelect);
    }

    onTodayClick($event) {
        $event.stopPropagation();
        let timeObj = null;
        let selectedDate = null;
        let selectedDate_range = null;
        if (this.opts.showTime) {
            const { start } = this.getTimeValue(false);
            timeObj = start;
        }
        const { dateFormat, monthLabels, dateRangeDatesDelimiter, closeSelectorOnDateSelect, returnFormat } = this.opts;
        
        selectedDate = { ...this.initializedDate({ year: 0, month: 0, day: 0 }), ...timeObj };
        const isInDisableRange = this.utilService.isDisabledDate(selectedDate, this.opts);
        const earlier = this.utilService.isDateSameOrEarlier(selectedDate, this.opts.disableUntil);

        selectedDate = !isInDisableRange
            ? selectedDate
            : { ...selectedDate, ...(earlier ? this.opts.disableUntil : this.opts.disableSince) };

        const dateModel: IMyDateModel = this.utilService.getDateModel(
            selectedDate,
            selectedDate_range,
            dateFormat,
            monthLabels,
            dateRangeDatesDelimiter,
            returnFormat
        );
        this.dateChanged(dateModel, closeSelectorOnDateSelect);
    }



    onDynamicOkClick($event, dynamicviewRef) {
        if (dynamicviewRef) {
            const value = dynamicviewRef.getValue();
            const text = this.utilService.formatDynamicValue(value, this.opts.dynamicLocale, this.opts.localeId === 'EN_US');
            value.text = text;
            this.opts.dynamicValueChanged(value);
        }
    }

    initializedDate(date: IMyDate, otherDate: IMyDate = { year: 0, month: 0, day: 0 }): IMyDate {
        const daysInMonth: Array<number> = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        if (!this.utilService.isInitializedDate(date) && !this.utilService.isInitializedDate(otherDate)) {
            const year = new Date().getFullYear();
            const month = new Date().getMonth() + 1;
            const day = new Date().getDate();
            return this.utilService.isDisabledDate({ year, month, day }, this.opts) ? this.opts.disableUntil : { year, month, day };
        } else if (!this.utilService.isInitializedDate(date)) {
            const year = otherDate.month + 1 > 12 ? otherDate.year + 1 : otherDate.year;
            let month = otherDate.month + 1 > 12 ? 1 : otherDate.month + this.opts.monthRangeValue;
            if (!date.month) {
                month = otherDate.month;
            }
            const day = otherDate.day < 1 || otherDate.day > daysInMonth[month - 1] ? 1 : otherDate.day;
            return this.utilService.isDisabledDate({ year, month, day }, this.opts) ? this.opts.disableSince : { year, month, day };
        }
        return date;
    }

    setTime(date: any) {
        const { dateFormat, monthLabels, dateRangeDatesDelimiter, closeSelectorOnDateSelect, returnFormat } = this.opts;
        if (date instanceof Date) {
            if (this.opts.showType !== 4 && !this.opts.dateRange) {
                let targetDate: IMyDate;
                if (this.opts.showTime) {
                    targetDate = {
                        year: date.getFullYear(),
                        month: date.getMonth() + 1,
                        day: date.getDate(),
                        hour: date.getHours(),
                        minute: date.getMinutes(),
                        second: date.getSeconds()
                    };
                } else {
                    targetDate = { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
                }
                const dateModel: IMyDateModel = this.utilService.getDateModel(
                    targetDate,
                    null,
                    dateFormat,
                    monthLabels,
                    dateRangeDatesDelimiter,
                    returnFormat
                );
                this.dateChanged(dateModel, closeSelectorOnDateSelect);
            } else {
                // å¯ç¨å¨éæ©æ¶  å¿«æ·æé®åæ°ä¸ºåä¸ªæ¥æ
                const dateModel: IMyDateModel = this.utilService.getDateModel(
                    null,
                    this.utilService.getNowWeekTime(date),
                    dateFormat,
                    monthLabels,
                    dateRangeDatesDelimiter,
                    returnFormat
                );
                this.dateChanged(dateModel, closeSelectorOnDateSelect);
            }
        } else if (date instanceof Object && this.opts.dateRange) {
            let targetDateRange: IMyDateRange;
            const { begin, end } = date;
            if (!begin || !end) {
                return;
            }
            if (this.opts.showTime) {
                targetDateRange = {
                    begin: {
                        year: begin.getFullYear(),
                        month: begin.getMonth() + 1,
                        day: begin.getDate(),
                        hour: begin.getHours(),
                        minute: begin.getMinutes(),
                        second: begin.getSeconds()
                    },
                    end: {
                        year: end.getFullYear(),
                        month: end.getMonth() + 1,
                        day: end.getDate(),
                        hour: end.getHours(),
                        minute: end.getMinutes(),
                        second: end.getSeconds()
                    }
                };
            } else {
                targetDateRange = {
                    begin: { year: begin.getFullYear(), month: begin.getMonth() + 1, day: begin.getDate() },
                    end: { year: end.getFullYear(), month: end.getMonth() + 1, day: end.getDate() }
                };
            }
            const dateModel: IMyDateModel = this.utilService.getDateModel(
                null,
                targetDateRange,
                dateFormat,
                monthLabels,
                dateRangeDatesDelimiter,
                returnFormat
            );
            this.dateChanged(dateModel, closeSelectorOnDateSelect);
        } else {
            // console.warn('åæ°å¿é¡»ç¬¦åè¦æ±ï¼');
        }
    }

    onSelectCurrentWeek($event: MouseEvent) {
        $event.stopPropagation();
        const firstDay = this.opts.firstDayOfWeek === 'su' ? 'æ¥': 'ä¸';
        const { begin, end } = this.dateHlp.getNowWeekTime(new Date(), firstDay);
        const year = new Date().getFullYear();
        const weekNbr = this.utilService.getWeekNumber(begin);

        const showTime = this.opts.returnFormat && this.opts.returnFormat.toLocaleLowerCase().indexOf('hh:mm') > -1;
        this.selectedWeek = { weekNbr, year };

        if (showTime) {
            begin['hour'] = 0;
            begin['minute'] = 0;
            begin['second'] = 0;

            end['hour'] = 23;
            end['minute'] = 59;
            end['second'] = 59;
        }

        this.selectDate(begin);
        this.selectDate(end);
    }

    onDynamicValueChanged($event) {
        this.btnDynamicDisabled = !$event;
    }

    onDayCellClickedForMultiDates(cell: IMyCalendarDay, isSecondCalendar?: boolean): void {
        if (cell.cmo === 1) {
            this.onPrevNavigateBtnClicked(true, isSecondCalendar);
        } else if (cell.cmo === 3) {
            this.onNextNavigateBtnClicked(true, isSecondCalendar);
        }
        const { dateFormat, monthLabels, maxSelected, closeSelectorOnDateSelect, showTime, returnFormat, selectedOrderBy } = this.opts;
        let selectedDates = [];
        const isSelected = this.selectedDates.find(n => this.utilService.isDateSame(n, cell.dateObj));
        if (!isSelected) {
            if (!maxSelected || (maxSelected && this.selectedDates.length < maxSelected)) {
                selectedDates = [...this.selectedDates, { ...cell.dateObj, value: this.utilService.formatDate(cell.dateObj, dateFormat, monthLabels) }];
            } else {
                selectedDates = [...this.selectedDates];
                if (this.showNotify) {
                    this.showNotify();
                }
            }
        } else {
            selectedDates = this.selectedDates.filter(n => n!== isSelected);
        }

        selectedDates = this.utilService.orderSelectedDates(selectedDates, selectedOrderBy);

        this.selectedDates = selectedDates;
        this.resetMonthYearSelect(isSecondCalendar);
    }

    onMultiDatesOkClicked($event: MouseEvent) {
        $event.stopPropagation();
        this.multiDatesChanged(this.selectedDates);
    }

    onMultiDateRemoved(removeItem) {
        this.selectedDates = this.selectedDates.filter(n => n!== removeItem);
    }

    onMultiDateClear($event) {
        this.selectedDates = [];
    }

    showGoBackToday() {
        // const { monthNbr, year } = this.visibleMonth;
        // const { year: currentYear, month } = this.getToday();
        // return monthNbr != month || year != currentYear;
        // TODO: åºé´éæ©æ¶ï¼å¤æ­æ¯å¦æ¾ç¤ºè¿åä»å¤©æé®
        return false;
    }

    private setCalendarView(year, month) {
        if (this.visibleMonth.year != year || this.visibleMonth.monthNbr != month) {
            this.visibleMonth = {
                monthTxt: this.opts.monthLabels[month],
                monthNbr: month,
                year: year,
                yearTxt: this.opts.yearTxt
            };

            this.selectedMonth.year = year;
            this.selectedMonth.monthNbr = month;

            //tfs638280
            this.selectMonth = false;
            this.selectYear = false;

            this.generateCalendar(month, year, true);
        }
    }

    gototodayView($event) {
        const { year, month } = this.getToday();
        this.setCalendarView(year, month);
    }

    onSelectDateClicked($event) {
        if (!$event) {
            return;
        }
        const { year, month } = $event;
        this.setCalendarView(year, month);
    }




    private makeRange(
        length: number,
        step: number = 1,
        start: number = 0
    ): number[] {
        step = Math.ceil(step);
        return new Array(Math.ceil(length / step))
            .fill(0)
            .map((_, i) => (i + start) * step);
    }

    private buildHours() {
        let hourRanges = 24;
        let disabledHours = this.disabledHours && this.disabledHours();
        let startIndex = 0;
        
        let hourRange = this.makeRange(hourRanges, this.opts.hourStep, startIndex).map(
            r => {
                return {
                    index: r,
                    disabled:
                        this.disabledHours && disabledHours.indexOf(r) !== -1
                };
            }
        );
        // ç§»é¤ç¦ç¨çå¼
        return hourRange.filter( n => {
            return !(n.disabled);
        });
    }

    private buildMinutes(timeObj: any) {
        let minuteRange = this.makeRange(60, this.opts.minuteStep).map(r => {
            return {
                index: r,
                disabled:
                    this.disabledMinutes &&
                    this.disabledMinutes(timeObj.hours!).indexOf(r) !== -1
            };
        });

        // ç§»é¤ç¦ç¨çå¼
        return minuteRange.filter( n => {
            return !(n.disabled);
        });
    }

    private buildSeconds(timeObj: any) {
        let secondRange = this.makeRange(60, this.opts.secondStep).map(r => {
            return {
                index: r,
                disabled:
                    this.disabledSeconds &&
                    this.disabledSeconds(
                        timeObj.hours!,
                        timeObj.minutes!
                    ).indexOf(r) !== -1
            };
        });

        // ç§»é¤ç¦ç¨çå¼
        return secondRange.filter( n => {
            return !(n.disabled);
        });
    }

    checkTimeValues(timeValue: string) {
        if (timeValue) {
            let times = timeValue.split(':').map(n => parseInt(n, 10));
            const timeObj = {
                hour: times[0],
                minute: times[1],
                second: times[2]
            };

            if (this.opts.hourStep > 1) {
                const hours = this.buildHours();
                if (!hours.find(n => n.index === timeObj.hour)) {
                    timeObj.hour = 0;
                }
    
            }
    
            if (this.opts.minuteStep > 1) {
                const minutes = this.buildMinutes({ hours: timeObj.hour });
                if (!minutes.find(n => n.index === timeObj.minute)) {
                    timeObj.minute = 0;
                }
            }
    
            if (this.opts.secondStep> 1) {
                const seconds = this.buildSeconds({ hours: timeObj.hour, minutes: timeObj.minute });
                if (!seconds.find(n => n.index === timeObj.second)) {
                    timeObj.second = 0;
                }
            }

            return `${timeObj.hour || '00'}:${timeObj.minute || '00'}:${timeObj.second || '00'}`;
        }

        return timeValue;
    }

    checkTimeValue(dateObj: IMyDate) {
        if (!this.opts.showTime) {
            return;
        }
        if (this.opts.hourStep > 1) {
            const hours = this.buildHours();
            if (!hours.find(n => n.index ===  parseInt(''+ dateObj.hour, 10))) {
                dateObj.hour = 0;
            }

        }

        if (this.opts.minuteStep > 1) {
            const minutes = this.buildMinutes({ hours: dateObj.hour });
            if (!minutes.find(n => n.index === parseInt(''+dateObj.minute, 10))) {
                dateObj.minute = 0;
            }
        }

        if (this.opts.secondStep> 1) {
            const seconds = this.buildSeconds({ hours: dateObj.hour, minutes: dateObj.minute });
            if (!seconds.find(n => n.index === parseInt(''+dateObj.second, 10))) {
                dateObj.second = 0;
            }
        }
    }

    onClickCurrentMonth($event) {
        $event.stopPropagation();
        const today = this.getToday();
        this.selectedDate.month = today.month;
        this.selectedDate.year = today.year;

        this.visibleMonth = {
            monthTxt: this.opts.monthLabels[today.month],
            monthNbr: today.month,
            year: today.year,
            yearTxt: this.opts.yearTxt
        };

        this.onMonthCellClicked({nbr: today.month, name: '', currMonth: true, disabled: false}, false);
    }

    onClickCurrentYear($event) {
        $event.stopPropagation();
        const year = this.getToday().year;
        this.selectedDate.year = year;
        this.onYearCellClicked({year, currYear: true, disabled: false}, false);
        this.selectMonth = true;
    }

    private calendarStyle = {
        "margin-right": 0,
        height: '100%',
        width: '100px',
        "font-size": "15px"
    }

    btnTodayStyle = () => {
        const isDisalbed = this.utilService.isDisabledDate(this.getToday(), this.opts);
        return {
            "pointer-events": isDisalbed ? "none" : "auto",
            opacity: isDisalbed ? 0.3 : 1,
            ...this.calendarStyle
        }
    }

    btnCurrentMonthStyle = () => {
        const { year, month } = this.getToday();
        // const disabled: boolean =
        //             this.utilService.isMonthDisabledByDisableUntil(
        //                 { year, month, day: this.daysInMonth(month, year) },
        //                 this.opts.disableUntil
        //             ) || this.utilService.isMonthDisabledByDisableSince({ year, month, day: 1 }, this.opts.disableSince);
        const maxDate = { year: this.opts.disableSince.year, month: this.opts.disableSince.month, day: this.opts.disableSince.day };
        const minDate = { year: this.opts.disableUntil.year, month: this.opts.disableUntil.month, day: this.opts.disableUntil.day }; 
        const disabled = this.utilService.isMonthDisabledByDisableSince({ year, month, day: 1 }, maxDate) ||
                this.utilService.isMonthDisabledByDisableUntil({ year, month, day: this.daysInMonth(month || 0, year || 0) }, minDate);
        return {
            "pointer-events": disabled? "none" : "auto",
            opacity: disabled? 0.3 : 1,
            ...this.calendarStyle
        }
    }

    btnCurrentYearStyle = () => {
        const { year } = this.getToday();
        // const { monthNbr } = this.visibleMonth;
        // const disabled: boolean = this.utilService.isMonthDisabledByDisableUntil(
        //                 { year, month: monthNbr, day: this.daysInMonth(monthNbr, year)}, this.opts.disableUntil
        //             ) || this.utilService.isMonthDisabledByDisableSince({ year, month: monthNbr, day: 1 }, this.opts.disableSince);
        const disabled: boolean = year < this.opts.minYear || year > this.opts.maxYear;
        return {
            "pointer-events": disabled? "none" : "auto",
            opacity: disabled? 0.3 : 1,
            ...this.calendarStyle
        }
    }
}
